export const orderStatusKeys = {
  waitingForPayment: 'WaitingForPayment',
  pendingBalancePayment: 'PendingBalancePayment',
  balancePaymentExpired: 'BalancePaymentExpired'
};
